import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Browsers keep the scroll position across client-side navigations, and they
 * never act on a #hash that arrives through the router. This handles both:
 * jump to the target element when the URL carries a hash, reset to the top
 * otherwise.
 */
export default function ScrollToTop() {
  // `key` changes on every navigation, so re-clicking the same link re-scrolls.
  const { pathname, hash, key } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      return
    }

    document.querySelector(hash)?.scrollIntoView()
  }, [pathname, hash, key])

  return null
}
